import(/* webpackMode: "eager", webpackExports: ["VideoEditMainPanel"] */ "/app/apps/sb-shell/app/(darkHeader)/ai/video-edit/_components/MainPanel/VideoEditMainPanel.tsx");
